export const DEFAULT_TARGET = "_blank";
